import { config } from '@uhg-abyss/web/tools/config';

export const getLagoonEnv = () => {
  const appEnv = config('APP_ENV');
  if (appEnv === 'local') {
    return 'dev';
  }
  return appEnv;
};

export const mapUpdates = (updates, position) => {
  const filteredUpdates = updates.filter((update) => {
    return update.dataTestId.includes(position);
  });

  return filteredUpdates;
};
